// src/components/AppointmentsTabs.jsx
// Route-based tab bar shared by PatientAppointmentsPage (mounted twice, at
// /patient/appointments and /patient/appointments/navigator — see its own
// `only` prop) and PatientLabTestsPage. These are separate routes but
// present as one "My Appointments" destination in the sidebar — this is
// what makes them read as tabs of the same section instead of unrelated
// pages. Mirrors WalletBillingTabs.jsx.
//
// "Navigator" is its own tab rather than a filter atop the first one
// because a patient's navigator visits (follow-up check-ins) and doctor
// visits are different kinds of appointment with a different empty state
// and no shared self-service booking flow — the first tab keeps every
// appointment type mixed exactly as it always has, unaffected.

import React from 'react';
import { NavLink } from 'react-router-dom';

export default function AppointmentsTabs() {
  return (
    <div className="tabs-bar">
      <NavLink
        to="/patient/appointments"
        end
        className={({ isActive }) => `tab-btn${isActive ? ' active' : ''}`}
      >
        Doctor
      </NavLink>
      <NavLink
        to="/patient/appointments/navigator"
        className={({ isActive }) => `tab-btn${isActive ? ' active' : ''}`}
      >
        Navigator check-ins
      </NavLink>
      <NavLink
        to="/patient/lab-tests"
        className={({ isActive }) => `tab-btn${isActive ? ' active' : ''}`}
      >
        Lab Tests
      </NavLink>
      <NavLink
        to="/patient/visits"
        className={({ isActive }) => `tab-btn${isActive ? ' active' : ''}`}
      >
        Visit summaries
      </NavLink>
    </div>
  );
}
